<template>
<div class="no-data-box">
  <span class="no_wrap">
    <span class="no_data">
      <img src="@/assets/images/no_data.png">
      <p class="no_data_text">暂无数据</p>
    </span>
  </span>
</div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
/*暂无数据*/
.no-data-box{
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  .no_wrap {
  display: flex;
  .no_data {
    margin: 20px auto;
    text-align: center;
    img{
      width: 220px;
      height: 220px;
    }
    p{
      color: #999;
      margin: 0;
      margin-top: -30px;
    }
  }
}
}
</style>